import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Patient } from '../../../core/models/patient.model';
import { DatePipe } from '@angular/common';
import { GenderPipe } from '../../../shared/pipes/gender.pipe';

@Component({
    selector: 'app-patient-list',
    templateUrl: './patient-list.component.html',
    styleUrls: ['./patient-list.component.scss'],
    imports: [DatePipe, GenderPipe]
})
export class PatientListComponent {
  @Input() patients: Patient[];

  @Output() public patientSelect = new EventEmitter<Patient>();

  constructor() {}


  onPatientClick(patient: Patient) {
    this.patientSelect.emit(patient);
  }
}
